var feBuildDemoServerSideTheme = typeof global !== 'undefined' && global.FE_BRARY_THEME;
var feBuildDemoClientSideTheme = typeof window !== 'undefined' && window.FE_BRARY_THEME;
var feTheme = typeof process !== 'undefined' && process.env.FE_BRARY_THEME;
var theme = feBuildDemoServerSideTheme || feBuildDemoClientSideTheme || feTheme || 'domain';
export default theme;